module.exports = __webpack_public_path__ + "static/img/5.a9e974b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/zh/5.png
// module id = OzUr
// module chunks = 0